import type { GalleryImageProps, GalleryProps } from './Gallery.typed';
import * as Styled from './Gallery.styled';
import Icon from '../Icon/Icon';
import React from 'react';

const Gallery = React.forwardRef<HTMLDivElement, GalleryProps>((props, ref) => {
  const { children, index, setIndex, height, ...rest } = props;
  const items = Array.isArray(children) ? children : [children];
  const lastIndex = items.length - 1;

  const onClickNext = () => {
    if (index === lastIndex) {
      setIndex(0);
    } else {
      setIndex(index + 1);
    }
  };

  const onClickPrev = () => {
    if (index === 0) {
      setIndex(lastIndex);
    } else {
      setIndex(index - 1);
    }
  };

  return (
    <Styled.Gallery ref={ref} height={height} {...rest}>
      <Styled.Item>{items[index] ?? null}</Styled.Item>
      {items.length > 1 && (
        <Styled.Controls>
          <button
            type="button"
            onClick={onClickPrev}
            aria-label="Previous"
            disabled={index === 0}
          >
            <Icon name="ChevronDownOutline" size="l" />
          </button>
          <button
            type="button"
            onClick={onClickNext}
            disabled={index === items.length - 1}
            aria-label="Next"
          >
            <Icon name="ChevronDownOutline" size="l" />
          </button>
        </Styled.Controls>
      )}
    </Styled.Gallery>
  );
});

export const GalleryImage = (props: GalleryImageProps) => {
  return (
    <Styled.GalleryImage>
      <img {...props} alt={props.alt} />
    </Styled.GalleryImage>
  );
};

// Future proofing in case we need more control
export default Object.assign(Gallery, { GalleryImage });
